type Props = {
  labels: string[];
  currentStep: number;
};

export function OnboardingStepIndicator({ labels, currentStep }: Props) {
  return (
    <div className="pt-6 pb-8 px-2">
      <div className="flex items-center gap-3 w-full">
        {labels.map((label, index) => (
          <div key={label} className="flex-1 space-y-2">
            <div className="flex h-1.5 rounded-full overflow-hidden">
              {index < currentStep ? (
                <div className="h-full w-full bg-primary transition-all duration-500" />
              ) : index === currentStep ? (
                <>
                  <div className="h-full w-1/2 bg-primary transition-all duration-500" />
                  <div className="h-full w-1/2 bg-muted transition-all duration-500" />
                </>
              ) : (
                <div className="h-full w-full bg-muted transition-all duration-500" />
              )}
            </div>
            <p
              className={`text-xs font-medium transition-colors ${
                index <= currentStep
                  ? 'text-foreground'
                  : 'text-muted-foreground'
              }`}
            >
              {label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
